import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-[#F6F6F6] px-4 md:px-8 py-8 md:py-16" data-id="element-553">
      <div className="max-w-4xl mx-auto" data-id="element-554">
        <Link to="/stats" className="inline-flex items-center gap-2 mb-8 text-purple hover:text-yellow transition-colors duration-100" data-id="element-555">
          <ArrowLeft className="w-5 h-5" data-id="element-556" />
          <span className="font-display uppercase tracking-wide text-sm font-bold" data-id="element-557">
            Volver a Estadísticas
          </span>
        </Link>

        {/* Hero Section */}
        <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-[8px_8px_0px_0px_rgba(91,43,224,1)] p-6 md:p-12 mb-10 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-558">
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-purple uppercase tracking-tight mb-4" data-id="element-559">
            Política de Privacidad
          </h1>
          <p className="text-base md:text-lg text-[#1A1A1A] leading-relaxed" data-id="element-560">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-CL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-561">
          {/* Introduction */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-562">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-563">
              Introducción
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-564">
              En (Not) Parásitos, respetamos tu privacidad. Esta política
              describe cómo manejamos la información cuando visitas nuestro
              sitio web. Nuestra plataforma está diseñada para ser transparente
              y no recopilamos datos personales de nuestros usuarios.
            </p>
          </div>

          {/* Data Collection */}
          <div className="bg-lavender border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-565">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-566">
              Información que NO recopilamos
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-567">
              (Not) Parásitos NO recopila, almacena ni procesa información
              personal de sus usuarios. Específicamente:
            </p>
            <ul className="space-y-3" data-id="element-568">
              <li className="flex items-start gap-3" data-id="element-569">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-570">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-571">
                  No recopilamos nombres, direcciones de correo electrónico,
                  números de teléfono ni ningún otro dato de contacto.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-572">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-573">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-574">
                  No utilizamos cookies de seguimiento ni herramientas de
                  análisis que identifiquen a usuarios individuales.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-575">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-576">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-577">
                  No compartimos información con terceros porque no recopilamos
                  ninguna información.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-578">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-579">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-580">
                  No creamos perfiles de usuario ni realizamos seguimiento de
                  comportamiento.
                </span>
              </li>
            </ul>
          </div>

          {/* Public Data */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-581">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-582">
              Datos públicos que mostramos
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-583">
              Toda la información que presentamos en (Not) Parásitos proviene de
              registros públicos oficiales de la Cámara de Diputadas y Diputados
              de Chile. Esta información incluye:
            </p>
            <ul className="space-y-2" data-id="element-584">
              <li className="flex items-start gap-3" data-id="element-585">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-586">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-587">
                  Nombres de diputados y diputadas (información pública)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-588">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-589">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-590">
                  Registros de asistencia e inasistencia a sesiones
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-591">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-592">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-593">
                  Horarios de ingreso a sesiones
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-594">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-595">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-596">
                  Partidos políticos y bancadas
                </span>
              </li>
            </ul>
            <p className="text-base text-[#1A1A1A] leading-relaxed mt-4" data-id="element-597">
              Estos datos son de dominio público y están disponibles en el sitio
              web oficial de la Cámara de Diputadas y Diputados.
            </p>
          </div>

          {/* Technical Info */}
          <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-598">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-599">
              Información técnica
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-600">
              Como cualquier sitio web, nuestro servidor puede registrar
              automáticamente información técnica básica cuando accedes a la
              página, como:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-601">
              <li className="flex items-start gap-3" data-id="element-602">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-603">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-604">
                  Dirección IP (necesaria para el funcionamiento técnico)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-605">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-606">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-607">
                  Tipo de navegador y sistema operativo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-608">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-609">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-610">
                  Páginas visitadas dentro del sitio
                </span>
              </li>
            </ul>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-611">
              Esta información se utiliza únicamente para el funcionamiento
              técnico del sitio y no se vincula a usuarios individuales ni se
              utiliza para crear perfiles.
            </p>

            {/* Infrastructure details */}
            <div className="bg-white border-2 border-purple p-4 rounded-none mt-4" data-id="element-612">
              <h3 className="font-display text-base font-bold text-purple uppercase mb-3" data-id="element-613">
                Infraestructura y almacenamiento de logs
              </h3>
              <ul className="space-y-2" data-id="element-614">
                <li className="flex items-start gap-3" data-id="element-615">
                  <span className="text-purple text-xl flex-shrink-0" data-id="element-616">•</span>
                  <span className="text-sm text-[#1A1A1A]" data-id="element-617">
                    <strong data-id="element-618">Servidor:</strong> Nuestro sitio web está alojado en
                    servidores de Hetzner ubicados en Europa.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-619">
                  <span className="text-purple text-xl flex-shrink-0" data-id="element-620">•</span>
                  <span className="text-sm text-[#1A1A1A]" data-id="element-621">
                    <strong data-id="element-622">Logs técnicos:</strong> Utilizamos Logfire para
                    almacenar logs técnicos del servidor (errores, rendimiento,
                    solicitudes HTTP) con fines de mantenimiento y diagnóstico.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-623">
                  <span className="text-purple text-xl flex-shrink-0" data-id="element-624">•</span>
                  <span className="text-sm text-[#1A1A1A]" data-id="element-625">
                    <strong data-id="element-626">Retención de logs:</strong> Los logs técnicos se
                    almacenan durante un máximo de 30 días y luego se eliminan
                    automáticamente. Estos logs no contienen información
                    personal identificable.
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="bg-purple border-brutal border-[#1A1A1A] rounded-none shadow-[8px_8px_0px_0px_rgba(255,217,61,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[6px_6px_0px_0px_rgba(255,217,61,1)] transition-all duration-100" data-id="element-627">
            <h2 className="font-display text-xl md:text-2xl font-bold text-yellow uppercase mb-4" data-id="element-628">
              Preguntas sobre privacidad
            </h2>
            <p className="text-base text-white leading-relaxed mb-4" data-id="element-629">
              Si tienes preguntas sobre esta política de privacidad o sobre cómo
              manejamos la información, puedes contactarnos en:
            </p>
            <a href="mailto:contacto.parasitos@gmail.com" className="inline-flex items-center gap-2 bg-yellow text-purple font-display uppercase text-xs sm:text-sm font-bold px-4 sm:px-6 py-3 border-2 border-[#1A1A1A] hover:bg-white hover:shadow-[0_0_8px_rgba(255,217,61,0.8)] transition-all duration-100 break-all" data-id="element-630">
              <span className="break-all" data-id="element-631">
                contacto.parasitos@protonmail.com
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>;
}